import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { clientService } from "@app/client/shared/client.service";

@Injectable()
export class ClientsDropdownResolver {
  constructor(private clientService: clientService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.clientService.clientListDropdown();
  }
}
